import React from 'react'
import { Form } from 'semantic-ui-react'

export default class VattinField extends React.PureComponent {
  render() {
    const { value, onChange } = this.props

    return (
      <Form.Input
        fluid
        required
        label="VATTIN"
        placeholder="e.g K0018784"
        onChange={e => onChange(e.target.value)}
        value={value}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/vattinField.js